<template>
    <div class="" style="height: 100%; display: flex">
        <img src="https://oss.yueshiwl.com/img/1673949967376/gwbanner.png" />
    </div>
</template>

<script>
export default {
    name: 'Banner',
    data() {
        return {
            index: 0,
            time: 2000
        };
    },
    created() {},
    methods: {}
};
</script>

<style scoped>
img {
    width: 100%;
}
/*.container {overflow: hidden;}*/
</style>
